<template>
<div class="content-main">
    <div class="left-main">
        <div class="left-main-content">
            <div class="left-main-text">
            
                <div class="title"> Optimize international trade  business environments and promote a borderless world
                    <div class="title_bg"></div>
                </div>
                <div class="labels mgt80 mgb30"></div>
                <p class="text-box mgb100">
                Based on the international trade in Sichuan, China, and focusing on trade as well as logistics, we have established mutually beneficial and win-win cooperative relations with hundreds of fantastic service providers locally and internationally.
                They provide services in customs affairs, logistics, finance and taxation, warehousing, and other services to over 6000 service enterprises.
 

                </p>
                <div class="btns-box">
                    <div class="btn-child" v-for="item in btnList" :key="item.text">
                        <img :src="item.icon" alt="" class="btn-icon">
                        <span>{{item.text}}</span></div>
                </div>
            </div>
            <div class="left-main-imgs">
                <img src="../assets/images/wzyf_icon.png" alt="" class="imgs"/>
                <p class="more-text">More <span class="mgr10">></span></p>
            </div>
        </div>
    </div>
    <div class="right-main">
        <div class="tagLabel-box">
            <div class="label-top">
                <div :class="{'icon-item':true,'active-icon':item.hasClass}" v-for="(item,index) in list" :key="index" :style="{backgroundImage: `url(${item.hasClass?active_icon:default_icon})`}" @click="changeTag(item)"></div>
            </div>
            <div class="label-bottom">
                <div class="label-bottom-top">
                    <div :class="{'active-child':item.hasClass,'default-child':true}" v-for="(item,index) in list" :key="index" @click="changeTag(item)"></div>
                </div>
                <div class="label-bottom-bottom">
                    <img src="../assets/images/icon_1.png" alt="" width="27px" height="37px">
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import top_active from "../assets/images/top_active.png"
import top_default from "../assets/images/top_default.png"
export default {
    name: "tagWzyf",
    props: {
        "vdata": {
            type: Array,
            default: [],
        }

    },
    data() {
        return {
            list: [],
            btnList: [{
                id: 0,
                icon: require("../assets/images/icon_3.png"),
                text: "Comprehensive services"
            }, {
                id: 0,
                icon: require("../assets/images/icon_4.png"),
                text: "Financial services"
            }, {
                id: 0,
                icon: require("../assets/images/icon_5.png"),
                text: "International logistics services"
            }],
            default_icon: top_default,
            active_icon: top_active
        }
    },
    created() {
        let curr = this.vdata;
        let result = [];
        //console.log(curr,"curr")
        curr.forEach((item, index) => {
            if (index % 2 == 0) {
                result.push(item);
            }
        })
        this.list = result;
        console.log(this.list, "vdata")
    },
    methods: {
        changeTag(item) {
            let curr = this.vdata;
            curr.forEach((tem, index) => {
                console.log(tem.id, item.id)
                if (tem.id == item.id) {
                    console.log(11111)
                    curr[index] = {
                        id: tem.id,
                        text: tem.text,
                        isText: tem.isText,
                        isShow: tem.isShow,
                        hasClass: true,
                    }
                } else {
                    curr[index] = {
                        id: tem.id,
                        text: tem.text,
                        isText: tem.isText,
                        isShow: tem.isShow,
                        hasClass: false,
                    }
                }
            })
            let result = [];
            curr.forEach((item, index) => {
                if (index % 2 == 0) {
                    result.push(item);
                }
            })
            this.list = result;
            this.$emit('godata', {
                item,
                index: item.id
            })
            console.log(curr, "curr")
        }
    }

}
</script>

<style lang="less" scoped>
.active-icon {
    width: 22px !important;
    height: 22px !important;
}

.btn-icon {
    margin-right: 6px;
    margin-left: 6px;
    width: 34px;
    height: 34px;
}

.content-main {
    //background-color: yellowgreen;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    .left-main {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .left-main-content {
            width: 1440px;
            height: 100%;
            //background-color: #ccc;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            //flex-direction: column;
        }
    }

    .right-main {
        position: absolute;
        top: 0;
        right: 0;
        width: 30px;
        height: 100%;
        padding-right: 60px;

        //background-color: rgb(167, 164, 164);
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .tagLabel-box {
            width: 40px;
            height: 100%;
            // margin-top: 160px;
            //border: 1px red solid;
            display: flex;
            justify-content: space-around;
            align-items: center;
            flex-direction: column;

            .label-top {
                width: 100%;
                height: 30%;
                display: flex;
                justify-content: space-around;
                align-items: center;
                flex-direction: column;

                //border: 1px green solid;

                .icon-item {
                    width: 8px;
                    height: 8px;
                    background-size: cover;
                    background-position: center center;
                }
            }

            .label-bottom {
                width: 100%;
                height: 30%;
                //border: 1px green solid;

                .label-bottom-top {
                    width: 100%;
                    height: 80%;
                    //border: 1px red solid;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                }

                .label-bottom-bottom {
                    width: 100%;
                    height: 20%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    //border:1px red solid;
                }
            }
        }
    }
}

.left-main-text {
    padding-top: 50px;
    margin-top: 120px;
    width: 40%;
    min-width: 640px;
    //border: 1px red solid;
    //height: 100%;

    .title {
        width: 100%;
        font-size: 35px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 44px;
        position: relative;
        z-index: 999;
       letter-spacing:5px; 
        // text-align: justify;

        .title_bg {
            position: absolute;
            top: 0%;
            left: 0%;
            width: 178px;
            height: 178px;
            margin-top: -50px;
            margin-left: -89px;
            border-radius: 50%;
            z-index: -1;
            background-color: #CC1F37;
        }
    }

    .labels {
        width: 39px;
        height: 5px;
        background: #CC1F37;
    }

    .text-box {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.85);
        line-height: 32px;
        text-align: justify;
    }

    .btns-box {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 52px;

        .btn-child {
            //width: 20%;
            //min-width: 177px;
            //height: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 22px;
            border: 1px solid #FFFFFF;
            margin-right: 60px;
            padding: 10px;
            line-height: 25px;

            &:last-child {
                margin-bottom: 0px;
            }
        }
    }
}

.left-main-imgs {
    padding-top: 60px;
    min-width: 640px;
    width: 40%;
    height: 536px;
    position: relative;
    margin-top: 120px;

    .more-text {
        position: absolute;
        right: 125px;
        bottom: 0px;
        //border: 1px red solid;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 22px;
        letter-spacing: 1px;
        padding-bottom: 20px;
        border-bottom: 2px #fff solid;
    }
    img{
    width: 100%;
    //height: 100%;
    position: relative;
    }

    //border:1px red solid;
}

.colorFB092B {
    color: #FB092B;
}

.mgb40 {
    margin-bottom: 40px;
}

.mgt80 {
    margin-top: 80px;
}

.mgb30 {
    margin-bottom: 30px;
}

.mgb100 {
    margin-bottom: 100px;
}

.mgr10 {
    margin-right: 10px;
}

.btn-go {
    width: 32px;
    height: 32px;
    background-color: #CC1F37;
    margin-top: 40px;
}

.default-child {
    width: 2px;
    height: 16%;
    background: rgba(255, 255, 255, 0.1);
}

.active-child {
    background: rgba(54, 169, 255, 0.5);
}

@media (max-width: 768px) {
    .content-main {
        .left-main {
            .left-main-content {
                width: 80%;
                flex-direction: column;
                justify-content: flex-start;

                .left-main-text {
                    padding-top: 0px;
                    margin-top: 40px;
                    min-width: 100%;

                    .labels {
                        margin-top: 7px !important;
                        margin-bottom: 10px;
                    }

                    .title {
                        width: 78%;
                        text-align: justify;
                        font-size: 12px;
                        line-height: 18px;

                        .title_bg {
                            width: 60px;
                            height: 60px;
                            margin-top: -20px;
                            margin-left: -30px;
                        }

                    }

                    .text-box {
                        font-size: 12px;
                        line-height: 18px;
                        margin-bottom: 20px !important;

                    }

                    .btns-box {

                        .btn-child {
                            font-size: 12px;
                            padding: 0 3px;
                            line-height: 12px;
                            height: 45px;
                            margin-right: 3px;

                            .btn-icon {
                                margin-right: 2px;
                                margin-left: 2px;
                                width: 15px !important;
                                height: 15px !important;
                            }
                        }
                    }

                }

                .left-main-imgs {
                    margin-top: 10px;
                    width: 100%;
                    min-width: 100%;
                    padding-top: 0px;
                    //border:1px red solid;

                    .more-text {
                        right: 0px;
                        bottom: 3px;
                        font-size: 12px;
                        padding-bottom: 5px;
                        line-height: 15px;
                    }
                    img{
                   width: 100%;
                    }
                }

            }
        }

        .right-main {
            padding-right: 5px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/tagWzyf.vue